import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

function TRANSLATE(str: string) {
  return str;
}

@Component({
  selector: 'app-nessun-risultato',
  templateUrl: './nessun-risultato.component.html',
  styleUrls: ['./nessun-risultato.component.css']
})

export class NessunRisultatoComponent implements OnChanges {

  @Input() tipologia: string;

  titolo = null;
  sottotitolo = null;

  ngOnChanges(changes: SimpleChanges): void {
    switch (this.tipologia) {
      case 'visite':
        this.titolo = TRANSLATE('nessun_risultato.visite.titolo');
        this.sottotitolo = TRANSLATE('nessun_risultato.visite.sottotitolo');
        break;
      case 'vini':
        this.titolo = TRANSLATE('nessun_risultato.vini.titolo');
        this.sottotitolo = TRANSLATE('nessun_risultato.vini.sottotitolo');
        break;
    }
  }
}
